import { TypeAheadFilter } from '@components/table/filters/TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';

import { useSearchOfferingInsuranceProducts } from '@services/offering/useSearchOfferingInsuranceProducts';
import { useProductOptions } from '@services/productOption/useProductOptions';
import { useMemo } from 'react';

export interface BusinessClassTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

/** FUTURE CONSIDERATIONS
 * at this time the used apis are not paginated/load more on scroll (but it does load 1000)
 * this in theory may eventually be a problem
 */
export const BusinessClassTypeaheadFilter = (componentProps: BusinessClassTypeaheadFilterProps) => {
  const { value, watchedField, selectedValues = {}, disabled } = componentProps;
  // will be a value when selected from list - but just a string if loaded from shared url
  const selectedOfferings = watchedField ? selectedValues?.[watchedField] : undefined;
  const offeringId = useMemo(() => {
    if (!selectedOfferings) {
      return 0;
    }

    if (!Array.isArray(selectedOfferings)) {
      return selectedOfferings.value ?? selectedOfferings;
    }

    if (selectedOfferings.length === 1) {
      return selectedOfferings[0]?.value ?? selectedOfferings[0];
    }
    if (selectedOfferings.length > 1) {
      // Multiple is not supported
      return undefined;
    }
  }, [selectedOfferings]);

  const { insuranceProducts } = useSearchOfferingInsuranceProducts(offeringId);

  // FUTURE: at some point we may need to handle multiple insurance products
  const insuranceProductId = insuranceProducts?.length > 0 ? insuranceProducts[0].id : '';
  const { productOptions } = useProductOptions(insuranceProductId);

  const items = productOptions?.items.map((ip) => {
    return {
      key: ip.id,
      value: ip.id,
      label: ip.name,
    };
  });

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled || (!value && items.length === 0)}
      label={componentProps.label}
      options={items ?? []}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      helperText={selectedOfferings?.length > 1 ? 'Only available if one product is selected' : undefined}
    />
  );
};
